import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HistoryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"history"}/>
}
